/** チュートリアル終了直後に登録フィードバックモーダルを開く */
export const FIRST_TIME_SHOW_REGISTRATION_FEEDBACK = 'first-time-show-registration-feedback';

/** チュートリアルオーバーレイのみ閉じる（フィードバック後〜ブックマークまで） */
export const FIRST_TIME_DISMISS_TUTORIAL_OVERLAY = 'first-time-dismiss-tutorial-overlay';

/** 分析ページでユーザー操作後に結果表示が完了した */
export const FIRST_TIME_ANALYSIS_RESULTS_DISPLAYED = 'first-time-analysis-results-displayed';

/** 上記イベント後、ブックマーク案内モーダルを出すまでの待ち（ms） */
export const BOOKMARK_GUIDE_DELAY_MS = 5000;

/**
 * チュートリアル終了後に登録フィードバックを開く（ページ遷移後も別インスタンスの Manager が拾えるようセッションに保持）
 */
export const SESSION_OPEN_REGISTRATION_FEEDBACK_AFTER_TUTORIAL =
    'first_time_open_registration_feedback_after_tutorial';

/** フィードバック完了後にブックマーク案内を出すための待機フラグ（セッション） */
export const SESSION_FIRST_TIME_AWAITING_BOOKMARK = 'first_time_awaiting_bookmark_after_analysis';

/** 分析で結果表示後にブックマーク案内を出すフラグ（セッション） */
export const SESSION_PENDING_BOOKMARK_AFTER_ANALYSIS = 'pending_bookmark_after_analysis';

/**
 * 初回 GET /api/user/info で isNewlyRegistered が true だったことを保持する。
 * 紹介コード登録成功後にサーバのセッションから初回フラグが消えても、同一タブ内でオンボーディングを続けるため。
 */
export const SESSION_STICKY_NEW_USER = 'isNewUser';

/** チュートリアル（分析・モバイル）でボトムシートを展開スナップへ */
export const ANALYSIS_TUTORIAL_SHEET_EXPAND_REQUEST = 'analysis-tutorial-sheet-expand-request';

/** チュートリアル: ピーク高さへ戻す */
export const ANALYSIS_TUTORIAL_SHEET_PEEK_REQUEST = 'analysis-tutorial-sheet-peek-request';
